import type { ContentLink } from '@backmarket/http-api/src/api-specs-content/models/content-link'

const EXCEPTION_PATHS: Array<string> = [
  '/bo-seller/',
  '/bo_merchant/',
  '/impact/',
]
const EXCEPTION_PATHS_WITH_QUALITY = [...EXCEPTION_PATHS, '/quality']
const envRegExp = /local|preprod|dse-.*\.dse|www/
const onelinkRegExp = /backmarket.onelink.me/

export function transformHref({
  href,
  currentUrl,
  disablePromisePage = false,
}: {
  href: string
  currentUrl: URL
  /**
   * When true, `/quality` is kept in the exception paths and treated as an
   * external route. Defaults to `false` so the param can eventually be removed without changing
   * behavior.
   */
  disablePromisePage?: boolean
}): ContentLink {
  try {
    const url = new URL(href)

    const isUrlEnvSubdomain = url.hostname.match(envRegExp)
    const currentHostname = currentUrl.hostname.replace(envRegExp, '')
    const exceptionPaths = disablePromisePage
      ? EXCEPTION_PATHS_WITH_QUALITY
      : EXCEPTION_PATHS
    const isExternalPath = exceptionPaths.some((path) =>
      url.pathname.match(path),
    )

    if (
      url.hostname.match(currentHostname) &&
      isUrlEnvSubdomain &&
      !isExternalPath
    ) {
      return { href: url.pathname + url.search + url.hash }
    }

    if (url.hostname.match(onelinkRegExp)) {
      return { href }
    }

    if (url.protocol === 'mailto:') {
      return { href }
    }

    return { href, target: '_blank', rel: 'nofollow' }
  } catch {
    return { href }
  }
}
